export { BookDetailPage } from './BookDetailPage';
